import React, { Component } from 'react';
import { Chart } from "react-google-charts";
import classnames from 'classnames';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import LocationDropDown from './LocationDropDown';
import utils from '../../../lib/utils';

import rightArrow from '../images/Triangle.svg'
import tooltip  from '../images/tooltip.svg'
import './index.scss';
import { func } from 'prop-types';

//const colors = ['#3396D4','#c3e2f7','#62C1FC','#c3e2f7'];
//const colors2= [];
const colors = ['#3396D4','#3396D4','#62C1FC','#62C1FC'];
const colors2 = ['#3396D4'];
const colors3 = ['#3396D4','#62C1FC']

const source_label = {
    'ALL': 'All',
    'MISSED_CALL': 'Missed Call',
    'DIRECT_TEXT': 'Direct Text',
    'LEAD_ENGAGE': 'Lead Engage',
    'WEB_CHAT': 'Web Chat',
    'WEB_TO_TEXT': 'Web to text',
    'WEB_STORE': 'Online booking',
    'INCOMING_VOICE_CALL': 'Voice AI Call',
}

const sources_list = ['MISSED_CALL',
    'DIRECT_TEXT',
    'LEAD_ENGAGE',
    'WEB_CHAT',
    'WEB_TO_TEXT',
    'WEB_STORE',
    'INCOMING_VOICE_CALL'];

const feature_enable_key = {
    MISSED_CALL: 'TWILIO_ENABLED',
    DIRECT_TEXT: 'TWILIO_ENABLED',
    WEB_TO_TEXT: 'WEB_TO_TEXT_ENABLED',
    WEB_CHAT: 'WEB_CHAT_ENABLED',
    LEAD_ENGAGE: 'LEAD_ENGAGE_ENABLED',
    WEB_STORE: 'WEB_STORE_ENABLED',
    INCOMING_VOICE_CALL: 'INCOMING_VOICE_ENABLED',
};

const roundTheDecimalHeader=function(value){
   return Math.round(Math.round(value * 100) / 100);
}
const calculateWithChaneel=function(value,trend){
    if(trend === 'TIME_SAVED'){
        const in_hrs = value/60;
        return numberWithCommas(Math.round(Math.round(in_hrs * 100) / 100));
    }else{
        return numberWithCommas(Math.round(Math.round(value * 100) / 100));
    }
}
const kFormatter= function(num) {
    if(Math.abs(num) > 999 && Math.abs(num) < 1000000){
        return Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k';
    }else if(Math.abs(num) >= 1000000){
        return Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + 'M';
    }else{
        return  Math.round(Math.sign(num)*Math.abs(num));
    }
  }

  const kFormatterTime= function(countinminutes) {
    const num = countinminutes/60;
    return Math.abs(num) > 999 ? Math.round(Math.sign(num)*((Math.abs(num)/1000).toFixed(1))) + 'k' : Math.round(Math.sign(num)*Math.abs(num))
  }
const numberWithCommas=  function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

const chartEvents = [
  {
    eventName: 'ready',
    callback({ chartWrapper }) {
      console.log('ready', chartWrapper.getChart());
      let texts = document.querySelectorAll('text[text-anchor="middle"]');
      const isBottonm = (texts.length === 0);
      texts = (texts.length === 0)? document.querySelectorAll('text[text-anchor="end"]'):texts;
      let x_position = texts.length > 0 ? texts[0].getAttribute('x') : 0;
      console.log('x_position', eval(x_position), texts);
      for (var i = 0; i < texts.length; i += 1) {
        var text = texts[i];
        console.log('x_position', eval(x_position), texts);
        if (x_position < 100) {
          let current_position = text.getAttribute('x');
          if (texts.length === 4) {
            text.setAttribute('x', eval(current_position) + 35);
            text.setAttribute('y', '421');
          } else if (texts.length === 12) {
            if ((i + 1) % 2 === 0 && !isBottonm) {
              text.setAttribute('x', eval(current_position) + 35);
              text.setAttribute('y', '421');
            } else {
              text.setAttribute('x', eval(current_position) + 15);
            }
          } else if (texts.length === 13) {
            text.setAttribute('x', eval(current_position) + 18);
          }
        }
      }
    },
  }
];

const getLabelForDomain=function(domain){
    if(domain === 'FITNESS'){
        return ['Enrollments','Conversation Handle Rate','Enrollment Request Conversion', 'Enrollment Requests','Enrollments Value'];
    }else{
        return ['Bookings','Conversation Handle Rate','Booking Request Conversion','Booking requests','Revenue Booked'];
    }
}
const getTooltipForDomain=function(domain){
    if(domain === 'FITNESS'){
        return 'The percentage of appointment requests<br/> TrueLark successfully converted <br/>into an enrollment on your calendar';
    }else{
        return 'The percentage of appointment requests<br/> TrueLark successfully converted <br/>into an appointment on your calendar';
    }
}

const getBookingRequestTooltipForDomain=function(domain){
    if(domain === 'FITNESS'){
        return 'Number of times a guest clicked on a link to book online';
    }else if(domain === 'DENTAL'){
        return 'Number of times a patient clicked on a link to book online';
    }else{
        return 'Number of times a guest asked to book or reschedule an appointment';
    }
}
class StatsContnet extends Component{
    constructor(props){
        super(props);
        this.state={
            filter:null,
            isStacked:false,
            data:[],
            processed_data : [],
            activeTrend:'CONVERSATIONS',
            compareWithBrand:true,
            selectedCompareLocation:{},
            comparingLocation:{},
            daterangeMap: {}
        }
    }

    componentDidMount(){
        this.setState({
            processed_data:this.processWithFilter(null,this.props),
        },()=>this.changeChannel(null))
    }
    getColors=(processed_data)=>{
        const { isStacked } = this.state;
        return (processed_data.length===12||processed_data.length===21||processed_data.length===18)?colors:(isStacked)?colors2:colors3;
    }
    componentWillReceiveProps(nextProps){
        if (this.props.business && nextProps.business && nextProps.business.selectedLocation !== this.props.business.selectedLocation) {
            this.setState({processed_data:this.processWithFilter(null,nextProps), isStacked:false});
        }
        if (this.props.dashboard && nextProps.dashboard && nextProps.dashboard.brandlocation !== this.props.dashboard.brandlocation) {
            this.setState({processed_data:this.processWithFilter(null,nextProps), isStacked:false});
        }
        if (this.props.dashboard && nextProps.dashboard && nextProps.dashboard.comparater !== this.props.dashboard.comparater) {
            this.setState({processed_data:this.processWithFilter(null,nextProps), isStacked:false});
        }
    }
    roundTheDecimal=(value)=>{
        const { activeTrend } = this.state;
        if(activeTrend === 'TIME_SAVED'){
            const in_hrs = value/60;
            return Math.round(in_hrs * 100) / 100;
        }else{
            return Math.round(Math.round(value * 100) / 100);
        }
     }

    getRangeForGraph=(range,business)=>{
        const { info , selectedLocation} = business;
        const { zone_id } = selectedLocation;
        const zone   = (zone_id)?zone_id.zone : info.TIMEZONE; 
        if(range==='SEVEN_DAYS'){
            let range_array = [];
            let rangeMap = {};
            for(let i=6;i>=0;i--){
                const key = moment().tz(zone).subtract(i, "days").format("ddd MM/DD");
                const value = moment().tz(zone).subtract(i, "days").format("MMM DD, YYYY");
                range_array.push(key);
                rangeMap[key] = value ;
            }
            this.setState({daterangeMap:rangeMap});
            return range_array;
        }else if(range==='FOUR_WEEKS'){
            let range_array = [];
            let rangeMap = {};
            for(let i=1;i<5;i++){
                const key = moment().tz(zone).subtract((i*7)-1, "days").format("MM/DD")+'-'+moment().tz(zone).subtract((i-1)*7, "days").format("MM/DD");
                const value = moment().tz(zone).subtract((i*7)-1, "days").format("MMM DD, YYYY")+'-'+moment().tz(zone).subtract((i-1)*7, "days").format("MMM DD, YYYY");
                rangeMap[key] = value;
                range_array.push(key);
            }
            this.setState({daterangeMap:rangeMap});
            return range_array.reverse();
        }else if(range==='THREE_MONTHS'){
            let range_array = [];
            let rangeMap = {};
            for(let i=0;i<3;i++){
                const key = moment().tz(zone).subtract(i, 'months').format('MMM YY');
                const value = moment().tz(zone).subtract(i, 'months').format('MMM YYYY');
                rangeMap[key] = value;
                range_array.push(key);
            }
            console.log('range_array',rangeMap);
            this.setState({daterangeMap:rangeMap});
            return range_array.reverse();
        }else if(range==='SIX_MONTHS'){
            let range_array = [];
            let rangeMap = {};
            for(let i=0;i<6;i++){
                const key = moment().tz(zone).subtract(i, 'months').format('MMM YY');
                const value = moment().tz(zone).subtract(i, 'months').format('MMM YYYY');
                rangeMap[key] = value;
                range_array.push(key);
            }
            console.log('range_array',rangeMap);
            this.setState({daterangeMap:rangeMap});
            return range_array.reverse();
        }
    }
    getPrefix = () =>{
        const { activeTrend } = this.state;
        if(activeTrend === 'REVENUE'){
            return '$';
        }else{
            return ''
        }
    }
    getSuffix = () =>{
        const { activeTrend } = this.state;
        if(activeTrend === 'BOOKING_REQUEST_RATE' || activeTrend === 'HANDLED_RATE' ){
            return '%';
        }else{
            return '';
        }
    }
    getHtmlTooltip =(key,label, value,location, showlocation)=>{
        const { daterangeMap } = this.state;
        const { brand_ids, studioId } = location;
        let filterd_label = location.business_name;
            if(brand_ids && studioId && brand_ids.includes(studioId)){
                filterd_label =  'All accounts avg';
            }
            const locationmarkup = (showlocation===false)?'':'<div style="padding:0 0 15px 0;font-size:13px;text-transform: uppercase;font-weight:800;white-space: nowrap;">'+filterd_label+'</div>';
        return '<div style="padding:15px 15px 15px 15px;background: rgba(0,0,0,0.6); color: #FFFFFF;">'+
            '<div style="padding:0 0 15px 0;font-size:13px;font-weight:800;">'+(daterangeMap[key]||key)+'</div>'+locationmarkup+
            '<div style="font-size:13px;">'+label+':  <span style="font-weight:800;">'+this.getPrefix()+numberWithCommas(value)+this.getSuffix()+'</span></div>'+
            '</div>';
    }
    getHtmlTooltipwithLocation= (key,label, value,filterlabel, filtervalue, location,showlocation)=>{
        const { daterangeMap } = this.state;
        const { brand_ids, studioId } = location;
        let filterd_label = location.business_name;
            if(brand_ids && studioId && brand_ids.includes(studioId)){
                filterd_label =  'All accounts avg';
            }
        const locationmarkup = (showlocation===false)?'':'<div style="padding:0 0 15px 0;font-size:13px;text-transform: uppercase;font-weight:800;white-space: nowrap;">'+filterd_label+'</div>';
        console.log('showlocation',showlocation,locationmarkup);
        return '<div style="padding:15px 15px 15px 15px; background: rgba(0,0,0,0.6); color: #FFFFFF">'+
            '<div style="padding:0 0 15px 0;font-size:13px;font-weight:800;">'+(daterangeMap[key]||key)+'</div>'+locationmarkup+
            '<div style="font-size:13px;">'+label+':  <span style="font-weight:800;">'+this.getPrefix()+numberWithCommas(value)+this.getSuffix()+'</span></div>'+
            '<div style="font-size:13px;">'+filterlabel+':  <span style="font-weight:800;">'+this.getPrefix()+numberWithCommas(filtervalue)+this.getSuffix()+'</span></div>'+
            '</div>';
    }
    processWithFilter=(filter,props, compBrand, selectedCompLocation)=>{
        const { result , business, dashboard } = props;
        const { compareWithBrand, activeTrend} = this.state;
        let comparater = {};
        let selectedLocation = compBrand?selectedCompLocation:props.selectedLocation;
        if((compareWithBrand||compBrand) && dashboard.brandlocation && selectedLocation.brand_ids && selectedLocation.brand_ids.includes(selectedLocation.studioId)){
            comparater= dashboard.brandlocation;
        } else{
            comparater= dashboard.comparater;
        }
        this.setState({
            comparingLocation:comparater
        })
        const { trend_type_metrics, range_type } = result.trend;
        const { bar_data, bar_total } = trend_type_metrics[this.state.activeTrend];
        let formatted_metrics_data =[];
        const range_for_graph = this.getRangeForGraph(range_type, business);
        if(!filter){
            if(business && business.selectedLocation && !utils.isEmptyObject(business.selectedLocation) &&business.selectedLocation.studioId!==business.id)
            {   
                if(comparater){
                const { trend } = comparater;
                formatted_metrics_data = range_for_graph.map((key, index)=>{
                    return [key, this.roundTheDecimal(bar_total[index]),this.getHtmlTooltip(key,'Total Conversations',this.roundTheDecimal(bar_total[index]),business.selectedLocation
                    ), this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_total[index]),this.getHtmlTooltip(key,'Total Conversations',this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_total[index]),selectedLocation
                    )]
                });
                formatted_metrics_data.unshift(['Range',business.selectedLocation.business_name,{ role: "tooltip", type: "string", p: { html: true } },selectedLocation.business_name, { role: "tooltip", type: "string", p: { html: true } }]);
                }else{
                    formatted_metrics_data = range_for_graph.map((key, index)=>{
                        return [key, this.roundTheDecimal(bar_total[index]), this.roundTheDecimal(bar_total[index])]
                    });
                    formatted_metrics_data.unshift(['Range','Total','All']);
                }
            } else {
                //let keys = Object.keys(bar_data);
                formatted_metrics_data = range_for_graph.map((key, index)=>{
                    return [key, this.roundTheDecimal(bar_total[index]), this.getHtmlTooltip(key,'All Conversations',this.roundTheDecimal(bar_total[index]),selectedLocation,false)]
                })
                formatted_metrics_data.unshift(['Range','Total Conversations',{ role: "tooltip", type: "string", p: { html: true } }]);
            }
            console.log('formatted_metrics_data',formatted_metrics_data);  
            return formatted_metrics_data;
        }else{
            if(business && business.selectedLocation && !utils.isEmptyObject(business.selectedLocation) && business.selectedLocation.studioId!==business.id)
            {
                let first_array = range_for_graph.map((key, index)=>{
                    const tooltipdata = this.getHtmlTooltipwithLocation(key,source_label[filter],this.roundTheDecimal(bar_data[filter][index]),'All Conversations',this.roundTheDecimal(bar_total[index]),business.selectedLocation);
                    return [key ,this.roundTheDecimal(bar_data[filter][index]),tooltipdata, this.roundTheDecimal(bar_total[index]-bar_data[filter][index]),tooltipdata,'fill-opacity:0.4;',0,{},0 ,{} ,'fill-opacity:0.4;']
                    
                })
                const { trend } = comparater;
                //formatted_metrics_data.push(['', 0,{},0,{},'fill-opacity:0.4;',0,{} , 0, {}, 'opacity: 0']);
                for(let i=0; i<first_array.length;i++){
                    const key = first_array[i][0];
                    formatted_metrics_data.push(first_array[i]);
                    const tooltipdata = this.getHtmlTooltipwithLocation(key,source_label[filter],this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_data[filter][i]),'All Conversations',this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_total[i]), selectedLocation);
                    formatted_metrics_data.push(['', 0,{},0,{},'fill-opacity:0.4;' ,this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_data[filter][i]),tooltipdata, this.roundTheDecimal(trend.trend_type_metrics[this.state.activeTrend].bar_total[i]-trend.trend_type_metrics[this.state.activeTrend].bar_data[filter][i]),
                    tooltipdata, 'fill-opacity:0.4;']);
                         if(i!==first_array.length-1){
                    formatted_metrics_data.push(['',0,{},0,{},'fill-opacity:0.4;', 0 ,{}, 0, {}, 'opacity: 0']);
                         }
                }
                formatted_metrics_data.unshift(['Range','',{ role: "tooltip", type: "string", p: { html: true } },'', { role: "tooltip", type: "string", p: { html: true } },{role: 'style'},source_label[filter],{ role: "tooltip", type: "string", p: { html: true } },'All',{ role: "tooltip", type: "string", p: { html: true } }, {role: 'style'}]);
            }else{
                formatted_metrics_data = range_for_graph.map((key, index)=>{
                    const tooltip = this.getHtmlTooltipwithLocation(key,source_label[filter],this.roundTheDecimal(bar_data[filter][index]),'All Conversations',this.roundTheDecimal(bar_total[index]), selectedLocation, false);
                    return [key, this.roundTheDecimal(bar_data[filter][index]),tooltip, this.roundTheDecimal(bar_total[index]-bar_data[filter][index]), tooltip ,'fill-opacity:0.4;']
                })
                formatted_metrics_data.unshift(['Range',source_label[filter], { role: "tooltip", type: "string", p: { html: true } } ,'All Conversations',{ role: "tooltip", type: "string", p: { html: true } },{ role: "style" }]);
            }
         
            console.log('formatted_metrics_data',formatted_metrics_data);
            return formatted_metrics_data;
        }
    }

    changeChannel=(channel,result)=>{
        const {  activeTrend } = this.state;
        const { business } = this.props;
        const value = channel?result.trend.trend_type_metrics[activeTrend].source_wise_totals[channel]:this.props.result.trend.trend_type_metrics[activeTrend].total;
       const count = Math.round(value * 100) / 100;
       if((business.selectedLocation.studioId===business.id || utils.isEmptyObject(business.selectedLocation))&&  count ===0){
        const processed_data = [['Data',{role: 'annotation', type: 'string'}],[0,'No Data to Display']];

        this.setState({
            processed_data,
            isStacked:channel?true:false,
            filter:channel
        }) 

       }else{
       this.setState({
            processed_data:this.processWithFilter(channel,this.props),
            isStacked:channel?true:false,
            filter:channel
        }) 
        }
    }

    changeTrend=(trend)=>{
        this.setState({
            activeTrend:trend
        },() => {this.changeChannel(null);});
    }
    
    changeCompareLocatin=(location)=>{
        console.log('location',location)
        const { result, setDropDownLocation} = this.props;
        const {range_type, guest_type } = result.trend;
        setDropDownLocation(location);
        if(!location.brand_ids.includes(location.studioId)){
            this.setState({
                compareWithBrand:false,
            },()=>{
            this.props.getMetrics({
                business_id: location.studioId,
                selectedDateRange: range_type,
                selectedUserType: guest_type,
                compare:true
              });
            });
        }else{
            this.setState({
                compareWithBrand:true,
                processed_data:this.processWithFilter(null,this.props,true,location)
            })
        }
    }
    filerChannels=(source_wise_totals, selectedLocation)=>{
        let sources_availabel = Object.keys(source_wise_totals);
        const sources_sorted = sources_list.filter(source=>sources_availabel.includes(source)); 
        console.log('auth',  this.props.auth);
        let sources = [];
        if(utils.isEmptyObject(selectedLocation)){
            const { auth } = this.props;
            sources = sources_sorted.filter(source=>auth.features.includes(feature_enable_key[source]));
        }else{
            const { auth } = this.props;
            const features = auth.features || selectedLocation.features;
            sources = sources_sorted.filter(source=>features.includes(feature_enable_key[source]));
        
        }
        return sources;
    }

    render(){
            const {result, business, selectedLocation, dashboard, auth} = this.props;
            const { info, locations} = business;
            const { comparater  } = dashboard;
            const { domain, booking_software} = auth;
            const { isStacked, processed_data ,filter,activeTrend , comparingLocation} = this.state;
            const { trend } = result;
            const { BOOKINGS,BOOKING_REQUEST_RATE,CONVERSATIONS,HANDLED_RATE,REVENUE,TIME_SAVED, CONVERSATIONS_AVAILABILITY_REQUESTED} = trend.trend_type_metrics;
            console.log('info',auth);
            return(
                <div className="stats-container">
                    <div className="stats-container__header">
                    <ReactTooltip />
                    <div className="counter-list">
                        <div className="counter" onClick={()=>this.changeTrend('CONVERSATIONS')}>
                            <div className="value black">{numberWithCommas(roundTheDecimalHeader(CONVERSATIONS.total))}</div>
                        </div>
                        <div className="counter" onClick={()=>this.changeTrend('BOOKINGS')}>
                            <div className="value blue">{numberWithCommas(roundTheDecimalHeader(BOOKINGS.total))}</div>
                        </div>
                        <div className="counter" onClick={()=>this.changeTrend('HANDLED_RATE')}>
                            <div className="value blue">{roundTheDecimalHeader(HANDLED_RATE.total)}%</div>
                        </div>
                        {booking_software !=='SCIBLER' ?
                        (<>{BOOKING_REQUEST_RATE &&
                        <div className="counter" onClick={()=>this.changeTrend('BOOKING_REQUEST_RATE')}>
                            <div className="value blue">{roundTheDecimalHeader(BOOKING_REQUEST_RATE.total)}%</div>
                        </div>}</>):
                        (<>{CONVERSATIONS_AVAILABILITY_REQUESTED &&
                        <div className="counter" onClick={()=>this.changeTrend('CONVERSATIONS_AVAILABILITY_REQUESTED')}>
                            <div className="value blue">{roundTheDecimalHeader(CONVERSATIONS_AVAILABILITY_REQUESTED.total)}</div>
                        </div>}</>)
                        }
                        <div className="counter" onClick={()=>this.changeTrend('TIME_SAVED')}>
                            <div className="value blue">{kFormatterTime(TIME_SAVED.total) }</div>
                        </div>
                        <div className="counter" onClick={()=>this.changeTrend('REVENUE')}>
                            <div className="value blue">${kFormatter(REVENUE.total)}</div>
                        </div>
                    </div>
                    <div className="label-list">
                        <div className={classnames('label', {'active-trend':activeTrend === 'CONVERSATIONS'})} onClick={()=>this.changeTrend('CONVERSATIONS')}>
                            <div className="title">Conversations</div>
                        </div>
                        <div className={classnames('label', {'active-trend':activeTrend === 'BOOKINGS'})} onClick={()=>this.changeTrend('BOOKINGS')}>
                            <div className="title">{getLabelForDomain(domain)[0]}</div>
                        </div>
                        <div className={classnames('label', {'active-trend':activeTrend === 'HANDLED_RATE'})} onClick={()=>this.changeTrend('HANDLED_RATE')}>
                            <div  className="title tooltip-img">{getLabelForDomain(domain)[1]} <img data-multiline="true" data-tip="The percentage of conversations<br/> that TrueLark handled fully,<br/> without needing follow-up" className="tooltip" src={tooltip}/></div>
                        </div>
                        {booking_software !=='SCIBLER' ?
                        (<>
                        {BOOKING_REQUEST_RATE &&
                        <div className={classnames('label', {'active-trend':activeTrend === 'BOOKING_REQUEST_RATE'})} onClick={()=>this.changeTrend('BOOKING_REQUEST_RATE')}>
                            <div  className="title tooltip-img">{getLabelForDomain(domain)[2]} <img data-multiline="true" data-tip={getTooltipForDomain(domain)} className="tooltip" src={tooltip}/></div>
                        </div>
                        }</>):
                        (<>
                        {CONVERSATIONS_AVAILABILITY_REQUESTED &&
                        <div className={classnames('label', {'active-trend':activeTrend === 'CONVERSATIONS_AVAILABILITY_REQUESTED'})} onClick={()=>this.changeTrend('CONVERSATIONS_AVAILABILITY_REQUESTED')}>
                            <div  className="title tooltip-img">{getLabelForDomain(domain)[3]} <img data-multiline="true" data-tip={getBookingRequestTooltipForDomain(domain)} className="tooltip" src={tooltip}/></div>
                        </div>
                        }</>)
                        }
                        
                        <div className={classnames('label', {'active-trend':activeTrend === 'TIME_SAVED'})} onClick={()=>this.changeTrend('TIME_SAVED')}>
                            <div className="title">Time Saved (hrs)</div>
                        </div>
                        <div className={classnames('label', {'active-trend':activeTrend === 'REVENUE'})} onClick={()=>this.changeTrend('REVENUE')}>
                        {booking_software !=='SCIBLER' ?
                            (<>{domain !== 'DENTAL'?
                            (<div className="title">{getLabelForDomain(domain)[4]}</div>):
                            (<div className="title tooltip-img">Revenue Booked<img data-multiline="true" data-tip="Estimated based on $1,000 for new patients <br/> and $100 for existing patients" className="tooltip" src={tooltip}/></div>)}
                            </>):
                            (
                                <div className="title tooltip-img">Revenue Booked<img data-multiline="true" data-tip="Estimated revenue booked based on Average Service Price. Update Average Service Price under AI Setup > Business Preferences" className="tooltip" src={tooltip}/></div>
                            )}
                        </div>
                    </div>
                </div>
                    <div className="stats-container__body">
                        <div className="meta-sidebar">
                            {(business &&  business.selectedLocation && business.selectedLocation.brand_ids && business.selectedLocation.brand_ids.includes(business.selectedLocation.studioId)) || (business &&  business.selectedLocation && utils.isEmptyObject(business.selectedLocation) ) ?
                             (<div className="channel">Channel Breakdown:</div>):
                             (<div className="channel"><div className="color-square" style={{background:colors3[0]}}></div>{business.selectedLocation.business_name}</div>)
                            }
                             <div className={classnames('conversation-label', {'active':filter === null})} onClick={()=>this.changeChannel(null)}>All ({calculateWithChaneel(trend.trend_type_metrics[activeTrend].total,activeTrend)}{this.getSuffix()})</div>
                             {this.filerChannels(result.trend.trend_type_metrics[activeTrend].source_wise_totals, business.selectedLocation).map((source,index)=>{
                                 return(
                                    <div  key={index} className={classnames('data-list', {'active':filter === source})} onClick={()=>this.changeChannel(source,result)}>
                                    <img src={rightArrow} alt="*"/> {source_label[source]} ({calculateWithChaneel(result.trend.trend_type_metrics[activeTrend].source_wise_totals[source],activeTrend)}{this.getSuffix()})
                                 </div>
                                 )
                             })}
                             {business &&  business.selectedLocation && !utils.isEmptyObject(business.selectedLocation) && business.selectedLocation.studioId!==business.id && !utils.isEmptyObject(comparingLocation) &&
                             <>
                             <div className="dropdown-container">
                             <div className="color-square" style={{background:colors3[1]}}></div>
                             <LocationDropDown 
                                info={info} 
                                locations={locations} 
                                setSelectedLocation={this.changeCompareLocatin} 
                                selectedLocation={selectedLocation}
                                locationHidden={business.selectedLocation}
                             />
                             </div>
                             <div  className={classnames('conversation-label', {'active':filter === null})}  onClick={()=>this.changeChannel(null)}>All ({calculateWithChaneel(comparingLocation.trend.trend_type_metrics[activeTrend].total, activeTrend)}{this.getSuffix()})</div>
                             {this.filerChannels(comparingLocation.trend.trend_type_metrics[activeTrend].source_wise_totals, business.selectedLocation).map((source,index)=>{
                                 return(
                                    <div key={index}  className={classnames('data-list', {'active':filter === source})} onClick={()=>this.changeChannel(source,result)}>
                                    <img src={rightArrow} alt="*"/> {source_label[source]} ({calculateWithChaneel(comparingLocation.trend.trend_type_metrics[activeTrend].source_wise_totals[source],activeTrend)}{this.getSuffix()})
                                 </div>
                                 )
                             })}
                             </>
                             }
                        </div>
                        {processed_data && 
                        <div className="graph" id="statgraph">
                             <Chart 
                                  width="800px"
                                  height="500px"
                                  chartType="ColumnChart"
                                  loader={<div>Loading Chart</div>}
                                  data={processed_data}
                                  chartEvents={chartEvents}
                                  options={{
                                    chartArea: { width: '85%' ,
                                    backgroundColor:{stroke: '#F9FAFC',
                                    strokeWidth: 3,
                                    fill:'#F9FAFC'}
                                    },
                                    colors: this.getColors(processed_data),
                                    isStacked: isStacked,
                                    legend:{position:'none'},
                                    bar: { groupWidth: (processed_data.length-1==4)?'60%':'85%' },
                                    tooltip: { isHtml: true },
                                    baselineColor:'#D3E0E7',
                                    hAxis: {
                                        baseline:0,
                                        viewWindow: { min: 0 },
                                        //scaleType: 'log',
                                        //maxAlternation: 1,
                                        //slantedTextAngle: 20,
                                        textStyle: {
                                          fontSize: 11,
                                          fontName:'Montserrat',
                                          color: '#96ADB9',
                                          fontWeight: 600,
                                          bold:true,
                                          italic: false
                                        },
                                        gridlines: {    
                                            color: '#D3E0E7',
                                            count: 6
                                        }
                                      },
                                      vAxis: {
                                        baseline:0,
                                        viewWindow: { min: 0 },
                                        //scaleType: 'log',
                                        textStyle: {
                                          fontSize: 13.23,
                                          fontName:'Montserrat',
                                          color: '#96ADB9',
                                          fontWeight: 600,
                                          bold:true,
                                          italic: false
                                        },
                                        gridlines: {color: '#D3E0E7', count: 6}
                                      },
                                      annotations: {
                                        stem: {
                                          color: 'transparent',
                                          length: 120
                                        }
                                      },
                                  }}
                                  
                            />
                            
                        </div>}
                    </div>
                </div>
            )
        }
}

export default StatsContnet;